import { Button, Card, Flex, Row } from 'antd';
import {FC} from 'react';
import {useNavigate} from 'react-router-dom';
import { RouteNames } from '../../router/routeNames';
import ForgetLogin from './form/ForgetLogin';

const ForgetPassword: FC = () => {
    const router = useNavigate();

    const clickRegistration = () => {
        router(RouteNames.REGISTRATION)
    }
    return (
        <>
            <div style={{position: 'absolute', right: 20, top: 30}}>
                <p style={{display: 'inline', margin: 10, fontWeight: 600, fontFamily: 'Manrope'}}>Нет аккаунта?</p>
                <Button onClick={clickRegistration} type='primary' style={{width: 200}}>Зарегистрироваться</Button>
            </div>
            <Row justify="space-around" align="middle" className="layout">
                <Flex vertical align='center' gap={30}>
                    <Card
                        style={{
                            borderRadius: 12,
                            width: 600,
                            height: 306,
                            paddingTop: '4%',
                            paddingLeft: 100,
                            paddingRight: 100,
                            boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)"
                        }}>
                        <ForgetLogin/>
                    </Card>
                    <div>
                        <p style={{display: 'inline', margin: 10, fontWeight: 600, fontFamily: 'Manrope'}}>Нет
                            аккаунта?</p>
                        <p onClick={clickRegistration} style={{
                            display: 'inline',
                            color: 'black',
                            textDecoration: 'underline',
                            cursor: 'pointer'
                        }}>Зарегистрироваться</p>
                    </div>
                </Flex>
            </Row>
        </>
    );
};

export default ForgetPassword;
